<template lang="pug">
    div
        Modal(
            title="Build your chart"
            v-model="isModalShow"
            width="1200"
            @on-visible-change="handleOnVisibleChange"
            :mask-closable="false"
            :styles="{top: '20px'}"
        )
            Row
                Col(span="16")
                    Form(:model="chartTemplateForm" ref="chartTemplateForm")
                        p(style="padding-bottom: 10px;") Pick a term that you may interested in. Eg: Domain, URI, HTTP Status.
                        FormItem(label="I'm looking for ..." prop="chartTemplateName")
                            FormSelect(
                                ref="chartTemplateFormSelect"
                                v-model="chartTemplateForm.chartTemplateName" 
                                :formData="chartTemplateForm" 
                                :formItem="chartTemplateOptions" 
                                style="width: 500px")
                Col(span="8")
                     p Show Chart Options
                     i-switch(v-model="chartTemplateForm.isShowChartParams")
            // 避免沒顯示也獲取了第一次資料
            Card(v-if="isModalShow")
                p(style="text-align: center; font-weight: bold; padding-bottom: 10px;") {{ chartTemplateForm.chartParams.chartTitle }}
                CDNChart(
                    :category="'newChart'"
                    ref="CDNChartPreview" 
                    :chartTitle="chartTemplateForm.chartParams.chartTitle"
                    :chartVisualizeType="chartTemplateForm.chartParams.chartVisualizeType"
                    :chartMetric="chartTemplateForm.chartParams.chartMetric"
                    :chartMetricGroupBy="chartTemplateForm.chartParams.chartMetricGroupBy"
                    :chartMetricGroupByTerms="chartTemplateForm.chartParams.chartMetricGroupByTerms"
                    :chartMetricGroupByTermSize="chartTemplateForm.chartParams.chartMetricGroupByTermSize"
                    :chartMetricGroupByFilters="chartTemplateForm.chartParams.chartMetricGroupByFilters"
                    :chartQueryFilters="chartTemplateForm.chartParams.chartQueryFilters"
                    style="height: 250px"
                )

            template(v-if="chartTemplateForm.isShowChartParams")
                Row(style="padding: 15px;" type="flex" justify="space-around")
                    Col(span="4")
                        Card(:class="cardPointerClass(chartTemplateForm.chartParams.chartVisualizeType == 'lineChart')" v-on:click.native="selectChartVisualizeType('lineChart')")
                            h4 Line
                            img.chart-logo(src="/static/img/charts/line_chart.svg")
                    Col(span="4")
                        Card(:class="cardPointerClass(chartTemplateForm.chartParams.chartVisualizeType == 'barChartHorizontal')" v-on:click.native="selectChartVisualizeType('barChartHorizontal')")
                            h4 Horizontal Bar 
                            img.chart-logo(src="/static/img/charts/bar_chart_horizontal.svg")
                    Col(span="4")
                        Card(:class="cardPointerClass(chartTemplateForm.chartParams.chartVisualizeType == 'barChartVertical')" v-on:click.native="selectChartVisualizeType('barChartVertical')")
                            h4 Vertical Bar
                            img.chart-logo(src="/static/img/charts/bar_chart_vertical.svg")
                    Col(span="4")
                        Card(:class="cardPointerClass(chartTemplateForm.chartParams.chartVisualizeType == 'pieChart')" v-on:click.native="selectChartVisualizeType('pieChart')")
                            h4 Pie
                            img.chart-logo(src="/static/img/charts/pie_chart.svg")
                    Col(span="4")
                        Card(:class="cardPointerClass(chartTemplateForm.chartParams.chartVisualizeType == 'singleNumberChart')" v-on:click.native="selectChartVisualizeType('singleNumberChart')")
                            h4 Number
                            img.chart-logo(src="/static/img/charts/number1.svg")
                Divider Settings
                Form(:model="chartTemplateForm.chartParams" ref="chartTemplateForm.chartParams")
                    Row
                        Col(span="12")
                            FormItem(label="Chart Name" prop="chartTitle")
                                Input(v-model="chartTemplateForm.chartParams.chartTitle" style="width: 380px" size="small")
                            FormItem(label="Metric" prop="chartMetric")
                                FormSelect(
                                    v-model="chartTemplateForm.chartParams.chartMetric" 
                                    :formData="chartTemplateForm.chartParams" 
                                    :formItem="chartMetricParams" 
                                    style="width: 450px"
                                )
                            FormItem(label="Group By" prop="chartMetricGroupBy")
                                FormSelect(
                                    v-model="chartTemplateForm.chartParams.chartMetricGroupBy" 
                                    :formData="chartTemplateForm.chartParams" 
                                    :formItem="chartMetricGroupByParams" 
                                    style="width: 450px"
                                )
                            FormItem(label="Term" prop="chartMetricGroupByTerms" v-if="chartTemplateForm.chartParams.chartMetricGroupBy == 'terms'")
                                FormSelect(
                                    v-model="chartTemplateForm.chartParams.chartMetricGroupByTerms" 
                                    :formData="chartTemplateForm.chartParams" 
                                    :formItem="chartMetricGroupByTermsParams" 
                                    style="width: 300px"
                                )
                            FormItem(label="Size" prop="chartMetricGroupByTermSize" v-if="chartTemplateForm.chartParams.chartMetricGroupBy == 'terms'")
                                InputNumber(
                                    v-model="chartTemplateForm.chartParams.chartMetricGroupByTermSize"
                                    :min="1"
                                    :max="10"
                                    @on-change="$refs.CDNChartPreview.getDataAndDraw()"
                                    style="width: 300px"
                                )
                            FormItem(label="Filters" prop="chartMetricGroupByFilters" v-if="chartTemplateForm.chartParams.chartMetricGroupBy == 'filters'")
                                ChartFilterSelector(
                                    v-model="chartTemplateForm.chartParams.chartMetricGroupByFilters"
                                    :formData="chartTemplateForm.chartParams"
                                    @input="$refs.CDNChartPreview.getDataAndDraw()"
                                    @contentChanged="$refs.CDNChartPreview.getDataAndDraw()"
                                )
                        Col(span="12")
                            FormItem(label="" prop="chartQueryFilters")
                                p Add some additional data queries in this chart, queries added here only effect current chart
                                ChartFilterSelector(
                                    v-model="chartTemplateForm.chartParams.chartQueryFilters"
                                    @input="$refs.CDNChartPreview.getDataAndDraw()"
                                    @contentChanged="$refs.CDNChartPreview.getDataAndDraw()"
                                )
            div(slot="footer")
                Button(@click="emitChartTemplate" type="primary" long) Add

</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
import CDNChart from "@/components/dashboard/CDNChart";
import ChartFilterSelector from "@/components/FormItems/ChartFilterSelector";

export default {
    name: "ChartLibrarySelector",
    components: { FormSelect, CDNChart, ChartFilterSelector },
    props: {
        // value: {
        //     default: () => [],
        // },
    },
    watch: {
        // value: function(newVal, oldVal) {
        //     this.$emit("input", newVal);
        // },
    },
    data() {
        return {
            isModalShow: false,
            chartTemplateForm: {
                isShowChartParams: false,
                chartTemplateName: "total_request_count_trending",
                chartParams: {
                    chartTitle: "Domain Request Count Trending",
                    chartMetric: "count",
                    chartMetricGroupBy: "none",
                    chartMetricGroupByTerms: "",
                    chartMetricGroupByTermSize: 3,
                    chartVisualizeType: "lineChart",
                    chartMetricGroupByFilters: [],
                    chartQueryFilters: []
                }
            },
            chartTemplateOptions: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartTemplateName = queryValue;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-templates?${queryString}`);
                    return result.data.options;
                },
                // queryParamsFields: [{ fieldName: "chartVisualizeType", queryIf: (val) => val !== "" }],
                // onQueryParamFieldsQueryIf: "firstAvailable",
                multiple: false,
                defaultVal: "total_request_count_trending",
                watchField: (value, formData) => {
                    let selectedOption = this.$refs.chartTemplateFormSelect.options.find(e => e.value == value);
                    console.log(selectedOption.chartParams);
                    this.chartTemplateForm.chartParams = selectedOption.chartParams;
                    console.log(selectedOption);
                    this.$refs.CDNChartPreview.getDataAndDraw();
                }
            },
            chartMetricParams: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartMetric = queryValue;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-metric?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "chartVisualizeType", queryIf: val => val !== "" }],
                onQueryParamFieldsQueryIf: "firstAvailable",
                multiple: false,
                defaultVal: "count",
                watchField: (value, formData) => {
                    this.$refs.CDNChartPreview.getDataAndDraw();
                }
            },
            chartMetricGroupByParams: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartMetricGroupBy = queryValue;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-metric-group-by?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "chartMetric", queryIf: val => val !== "" }],
                onQueryParamFieldsQueryIf: "firstAvailable",
                multiple: false,
                defaultVal: "none",
                watchField: (value, formData) => {
                    this.$refs.CDNChartPreview.getDataAndDraw();
                }
            },
            chartMetricGroupByTermsParams: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartMetricGroupByTerms = queryValue;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-metric-group-by-terms?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "chartMetric", queryIf: val => val !== "" }],
                onQueryParamFieldsQueryIf: "firstAvailable",
                multiple: false,
                defaultVal: "none",
                watchField: (value, formData) => {
                    this.$refs.CDNChartPreview.getDataAndDraw();
                }
            }
        };
    },
    computed: {},
    methods: {
        emitChartTemplate() {
            this.$emit("input", this.chartTemplateForm.chartParams);
            this.isModalShow = false;
        },
        handleOnVisibleChange(visible) {
            // if (visible) {
            //     this.$refs.CDNChartPreview.getDataAndDraw();
            // }
            if (!visible) {
                // this.$refs.chartTemplateForm.resetFields();
                this.chartTemplateForm = Object.assign(
                    {},
                    {
                        chartTemplateName: "total_request_count_trending",
                        isShowChartParams: false,
                        chartParams: {
                            chartTitle: "Domain Request Count Trending",
                            chartMetric: "count",
                            chartMetricGroupBy: "none",
                            chartMetricGroupByTerms: "",
                            chartMetricGroupByTermSize: 3,
                            chartVisualizeType: "lineChart",
                            chartMetricGroupByFilters: [],
                            chartQueryFilters: []
                        }
                    }
                );
            }
        },
        selectChartVisualizeType(chartVisualizeType) {
            if (this.chartTemplateForm.chartParams.chartVisualizeType !== chartVisualizeType) {
                this.chartTemplateForm.chartParams.chartVisualizeType = chartVisualizeType;
                this.$refs.CDNChartPreview.getDataAndDraw();
            }
        },
        cardPointerClass(isActive) {
            return isActive ? "cardPointer cardPointer-active" : "cardPointer";
        }
    },
    mounted() {},
    created() {},
    destroyed() {},
    beforeDestroy() {}
};
</script>
<style scoped>
.cardPointer {
    transform: scale(0.98);
    cursor: pointer;
    margin: 6px 6px 0px 6px;
    background: #fff;
    color: black;
    text-align: center;
}
.cardPointer-active {
    box-shadow: 5px 5px 10px 5px #dedfe0;
}
.chart-logo {
    width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormItems/ChartLibrarySelector.vue